const second = 1 * 1000
const minute = 60 * second
const hour = 60 * minute
const day = 24 * hour

const conferenceConfig = {
  // Next conference year.
  year: '2026',
  2026: {
    callForContent: {
      starts: '',
      submissionEnds: '2025-06-30T23:59:59-06:00',
      approvalStarts: '2025-09-15T12:59:59-06:00',
      ends: '2026-02-25T07:00:00.000Z',
    },
    callForExhibitors: {
      starts: '2025', // ???
      // NOTE: Exhibitors can start editing booths once the expoHall is closed.
      dashboardAccessStarts: '2025-10-06T18:00:00-06:00',
      submissionEnds: '2025-12-08T23:59:59-07:00',
      acceptanceEnds: '2026-02-18T23:59:59-07:00',
      promotionEditEnds: '2026-02-09T07:00:00-07:00',
      ends: '2026-02-18T23:59:59-07:00',
    },
    registration: {
      starts: '2025-09-24T08:00:00-07:00',
      pricing: {
        earlyBird: {
          starts: '2025-09-24T08:00:00-07:00',
          ends: '2026-01-18T23:59:59-07:00',
        },
        standard: {
          starts: '2026-01-19T00:00:01-07:00',
          ends: '2026-03-07T18:00:00-07:00',
        },
      },
      ends: '2026-03-07T18:00:00-07:00',
    },
    expoHall: {
      starts: '2026-03-05T08:00:00-07:00',
      // NOTE: generally this happens at the end of 3rd quarter.
      ends: '2026-10-06T18:00:00-06:00',
      promotions: {
        starts: '2026-02-25T07:00:00-07:00',
        ends: '2026-04-14T07:00:00-07:00',
      },
    },
    countdown: {
      // NOTE: this represents the phase, but also includes registration features.
      starts: '2026-01-28T08:00:00-07:00',
      // ends: // should be set to the conference start date
    },
    schedule: {
      // Should be the day registration starts
      previewStarts: '2025-09-25T07:00:00.000Z',
      // Should be the day countdown starts
      schedulingStarts: '2026-01-18T08:00:00-07:00',
      // I think this should be the end of the participation window.
      archiveStarts: '',
    },
    participationWindow: {
      // Valentines
      starts: '2026-02-14T07:00:00.000Z',
      // April Fools
      ends: '2026-04-01T07:00:00.000Z',
    },
    conference: {
      // NOTE: we have turned on the conference at 4:00 PM MST the Wednesday before for APAC.
      starts: '2026-03-05T16:00:00-07:00',
      // NOTE: the conference generally ends at 6:00 PM MST on Saturday but stays up for Japan to a later time.
      ends: '2026-03-07T18:00:00-07:00',
      resources: {
        // Syllabi are available a week before the conference opens.
        syllabiDownloadable: '2026-02-26T09:00:00-07:00',
        // Available when the conference starts at the presenters discretion.
        slidesDownloadable: '2026-03-05T16:00:00-07:00',
      },
    },
    discoveryDay: {
      starts: '2026-03-07T09:00:00-07:00',
      ends: '2026-03-07T15:00:00-07:00',
    },
    afterConference: {
      // starts: '', // should be set to the conference ends date for the current year
      // ends: // should be set to the registration for the next year
    },
  },
  2025: {
    conference: {
      start: '2025-03-06T16:00:00-07:00',
      end: '2025-03-08T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2025-03-08T09:00:00-07:00',
      ends: '2025-03-08T15:00:00-07:00',
    },
  },
  2024: {
    conference: {
      starts: '2024-02-29T16:00:00-07:00',
      ends: '2024-03-02T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2024-03-02T09:00:00-07:00',
      ends: '2024-03-02T15:00:00-07:00',
    },
  },
  2023: {
    conference: {
      starts: '2023-03-02T16:00:00-07:00',
      ends: '2023-03-04T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2023-03-04T09:00:00-07:00',
      ends: '2023-03-04T15:00:00-07:00',
    },
  },
  2022: {
    conference: {
      starts: '2022-03-03T16:00:00-07:00',
      ends: '2022-03-05T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2022-03-05T09:00:00-07:00',
      ends: '2022-03-05T15:00:00-07:00',
    },
  },
  2021: {
    conference: {
      starts: '2021-02-25T16:00:00-07:00',
      ends: '2021-02-27T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2021-02-27T09:00:00-07:00',
      ends: '2021-02-27T15:00:00-07:00',
    },
  },
  2020: {
    conference: {
      starts: '2020-02-26T16:00:00-07:00',
      ends: '2020-02-29T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2020-02-29T09:00:00-07:00',
      ends: '2020-02-29T15:00:00-07:00',
    },
  },
  2019: {
    conference: {
      starts: '2019-03-27T16:00:00-07:00',
      ends: '2019-03-30T18:00:00-07:00',
      london: {
        starts: '2019-10-24T16:00:00Z',
        ends: '2019-10-26T18:00:00Z',
      },
    },
    discoveryDay: {
      starts: '2019-03-30T16:00:00-07:00',
      ends: '2019-03-30T18:00:00-07:00',
      london: {
        starts: '2019-10-26T09:00:00Z',
        ends: '2019-10-26T15:00:00Z',
      },
    },
  },
  2018: {
    conference: {
      starts: '2018-02-28T16:00:00-07:00',
      ends: '2018-03-03T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2018-03-03T09:00:00-07:00',
      ends: '2018-03-03T15:00:00-07:00',
    },
  },
  2017: {
    conference: {
      starts: '2017-02-08T16:00:00-07:00',
      ends: '2017-02-11T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2017-02-11T09:00:00-07:00',
      ends: '2017-02-11T15:00:00-07:00',
    },
  },
  2016: {
    conference: {
      starts: '2016-02-03T16:00:00-07:00',
      ends: '2016-02-06T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2016-02-06T09:00:00-07:00',
      ends: '2016-02-06T15:00:00-07:00',
    },
  },
  2015: {
    conference: {
      starts: '2015-02-12T16:00:00-07:00',
      ends: '2015-02-14T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2015-02-14T09:00:00-07:00',
      ends: '2015-02-14T15:00:00-07:00',
    },
  },
  2014: {
    conference: {
      starts: '2014-02-06T16:00:00-07:00',
      ends: '2014-02-08T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2014-02-08T09:00:00-07:00',
      ends: '2014-02-08T15:00:00-07:00',
    },
  },
  2013: {
    conference: {
      startDate: '2013-03-21T16:00:00-07:00',
      endDate: '2013-03-23T18:00:00-07:00',
    },
    discoveryDay: {
      starts: '2013-03-23T09:00:00-07:00',
      ends: '2013-03-23T15:00:00-07:00',
    },
  },
  2012: {
    conference: {
      starts: '2012-02-02T16:00:00-07:00',
      ends: '2012-02-04T18:00:00-07:00',
    },
  },
  2011: {
    conference: {
      starts: '2011-02-10T16:00:00-07:00',
      endDate: '2011-02-12T18:00:00-07:00',
    },
  },

  // CONFERENCE DATES
  preEventStartTimestamp: '2025-02-26T07:00:00.000Z',
  startTimestamp: 1772726400000, // Thu Mar 05 2026 16:00:00.000 UTC
  endTimestamp: 1741395600000, // Sat Mar 7 2025 18:00:00 GMT-0700 (Mountain Standard Time)

  cfcSubmissionDeadlineTimestamp: 1751349599000, // Monday, June 30, 2025 11:59:59 PM GMT-06:00 DST
  cfcApprovalDeadlineTimestamp: 1757980799000, // Monday, September 15, 2025 12:59:59 PM GMT-06:00 DST

  enableSponsorsDashboardTimestamp: '2025-09-01T06:00:00.000Z',
  exhibitorDeadlineTimestamp: '2026-02-19T07:00:00.000Z',
  sponsorDeadlineTimestamp: '2026-02-19T07:00:00.000Z',

  attachmentsEditTimestamp: '2026-02-23T05:59:59.000Z',

  playerTimeFrame: 42 * day,

  // PROMOTIONS
  promotionsEditDeadlineTimestamp: '2026-02-28T07:00:00.000Z',
  promotionsStartTimestamp: '2026-02-25T07:00:00.000Z',
  promotionsEndTimestamp: '2026-04-14T07:00:00.000Z',

  // DOWNLOADABLE RESOURCES
  dlrEditDeadlineTimestamp: '2026-02-28T07:00:00.000Z',

  // HIGH RESOLUTION LOGOS
  hrlEditDeadlineTimestamp: '2026-02-28T07:00:00.000Z',

  // MAIN STAGE UPLOAD
  mainStageUploadDeadlineTimestamp: '2026-03-02T07:00:00.000Z',

  // CALL FOR PRESENTATIONS
  cfpEndTimestamp: '2026-02-25T07:00:00.000Z',

  // PROFILES
  profilesCreationDeadlineTimestamp: '2026-02-06T07:00:00.000Z',

  // SCHEDULE
  classPreviewTimestamp: '2025-09-25T07:00:00.000Z',

  // BOOTH
  enableSponsorsEditBoothTimestamp: '2025-10-06T06:00:00.000Z',
  boothEditDeadlineTimestamp: '2025-12-08T07:00:00.000Z',
}

export { second, minute, hour, day, conferenceConfig }
